// A book id is user-visible, at `/photo-books/:bookId`: base62 keeps it
// URL-safe, and eight characters of it cannot collide with the sibling route
// segments the editor's path already owns (`home`, `design`).
const BASE62_ALPHABET =
  '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

export const PHOTO_BOOK_ID_LENGTH = 8

const getRandomBase62Char = () =>
  BASE62_ALPHABET[Math.floor(Math.random() * BASE62_ALPHABET.length)]

export const mintPhotoBookId = (): string =>
  Array.from({ length: PHOTO_BOOK_ID_LENGTH }, getRandomBase62Char).join('')

// A book serialized before books had ids was the browser's only book, so every
// id-less payload read back is that same one book. It gets this fixed id rather
// than a minted one: minting would make each read look like a book this browser
// has never seen, and stack another copy of it on every load.
export const LEGACY_PHOTO_BOOK_ID = 'legacybk'
